import React from 'react';
import {
  Activity,
  Bell,
  ShoppingCart,
  TrendingUp,
  AlertOctagon,
  HelpCircle,
} from 'react-feather';
import { useChatbot } from './ChatbotContext';

// Sugestoes alinhadas com a persona Copiloto (T2 / Camada 2):
// alem de duvidas, oferece analise de sinais (alertas, recomendacoes,
// dashboard preditivo, churn) que exercitam as tools novas do chatbot.
const quickActions = [
  { label: 'Como estamos esse mes?', icon: <Activity size={14} /> },
  { label: 'Tenho alertas críticos?', icon: <Bell size={14} /> },
  { label: 'O que preciso comprar?', icon: <ShoppingCart size={14} /> },
  { label: 'Quais produtos vão zerar?', icon: <AlertOctagon size={14} /> },
  { label: 'Clientes em risco de churn?', icon: <TrendingUp size={14} /> },
  { label: 'Falar com suporte humano', icon: <HelpCircle size={14} /> },
];

/**
 * Botoes de acao rapida exibidos quando a conversa esta vazia.
 */
const ChatbotQuickActions = () => {
  const { sendMessage } = useChatbot();

  return (
    <div className="chatbot-quick-actions">
      <p className="chatbot-quick-actions-label">Pergunte ao copiloto:</p>
      {quickActions.map((action) => (
        <button
          type="button"
          key={action.label}
          className="chatbot-quick-action-btn"
          onClick={() => sendMessage(action.label)}
        >
          {action.icon}
          <span>{action.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ChatbotQuickActions;
